import { ca } from '@cian/analytics';

export const trackTradePopupShow = (id: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'trade_popup_show',
    products: [{ id }],
  });
};

export const trackTradePopupClick = (id: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'trade_popup_click',
    products: [{ id }],
  });
};
